// packages import
import { TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import { FC, useContext } from "react";
import { Link } from "react-router-dom";
// component import
import { CustomPagination } from "../common/CustomPagination";
import { StickyTable } from "../common/StickyTable";
import { CourtsMenu } from '../menus/Court';
import { CourtsSkeleton } from "../skeletons/CourtsSkeleton";
// others
import { COURTS_TABLE_HEADERS } from "../../constants";
import { AuthContext } from '../../context';
import { CourtsListingProps } from "../../interfaceTypes";
import { titleize } from "../../utils";

export const CourtListing: FC<CourtsListingProps> = ({ state, dispatch, loading }): JSX.Element => {
  const { isAdmin } = useContext(AuthContext)
  const { allCourts } = state || {}

  return (
    <StickyTable pagination={<CustomPagination loading={loading} />} height={isAdmin ? '350px' : '270px'}>
      <TableHead>
        <TableRow>
          {COURTS_TABLE_HEADERS.map((item, index) => {
            const lastIndex = COURTS_TABLE_HEADERS.length - 1 === index

            return (
              <TableCell
                component="th"
                key={index}
                sx={{ maxWidth: lastIndex ? '100px' : 'unset', minWidth: lastIndex ? '50px' : '150px' }}
              >
                {item}
              </TableCell>
            )
          })}
        </TableRow>
      </TableHead>

      {loading ?
        <CourtsSkeleton noOfRows={9} />
        :
        <TableBody>
          {allCourts?.map(court => {
            const { id, name, county, totalCaseCount } = court || {}
            const caseLength = (totalCaseCount || 0) > 0

            return (
              <TableRow key={id} hover>
                <TableCell>
                  <Link to={id || ''}>
                    <Tooltip title={titleize(name || '')} arrow placement='top'>
                      <Typography noWrap maxWidth='150px' color='primary.main' textTransform='capitalize'>
                        {titleize(name || '')}
                      </Typography>
                    </Tooltip>
                  </Link>
                </TableCell>

                <TableCell>
                  <Tooltip title={titleize(county || '--')} arrow placement='top'>
                    <Typography textTransform='capitalize' noWrap maxWidth="150px">
                      {county || '--'}
                    </Typography>
                  </Tooltip>
                </TableCell>

                <TableCell>{caseLength ? `${totalCaseCount} active cases` : 'No active cases'}</TableCell>

                <TableCell>
                  <CourtsMenu state={state} dispatch={dispatch} court={court} />
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      }
    </StickyTable>
  )
}